import React, { useState,useEffect } from "react";
import NumberFormat from 'react-number-format';

function InputNumber({ register, validatorInput, nameVal, setValue ,init, disabled=false, prefix = '', thousandSeparator='false', suffix = '', allowNegative = false}) {
  const [num, setNum] = useState(init);
  useEffect(() => {
    setValue(nameVal, num)
  }, []);

  useEffect(() => {
    if(disabled){
      setValue(nameVal, 0);
          setNum(0);
    }
  }, [disabled])
  return (
    <>

      <NumberFormat
        {...register(nameVal, {
          validate: (value) => validatorInput(value),
        })}
        name={nameVal}
        className="boxCounter"
        thousandsGroupStyle="thousand"
        disabled={disabled}
        value={num}
        defaultValue={num}
        decimalSeparator="."
        displayType="input"
        type="text"
        prefix={prefix ? prefix : ''}
        suffix={suffix ? suffix : ''}
        thousandSeparator={thousandSeparator == 'false' ? false : thousandSeparator == 'true' || thousandSeparator == true ? true : thousandSeparator}
        allowNegative={allowNegative}
        ref={register}
        fixedDecimalScale={false}
        decimalScale={thousandSeparator == 'false' ? 0 : undefined}
        onValueChange={(values) => {
          const { value } = values
          setValue(nameVal, Number(value));
          setNum(Number(value));
          validatorInput(value)
        }}
      />
    </>


  );
}

export default InputNumber;
